import { useEffect, useState } from "react";
import { Col } from "reactstrap";
import { Bar } from 'react-chartjs-2';
import { checkDatatype, formatGraphPower, roundToNearest } from "../utils/NumberUtils";
import { format } from "date-fns";

const ChartLayout = ({ posts, type, isAuto, date }) => {
    const [chart, setChart] = useState({
        max: [50, 1000, 100000],
        step: [10, 100, 10000],
        scale: [(10 * 5), (100 * 5), (10000 * 5)]
    });
    // const defaultDataset = [{
    //     type: 'bar',
    //     label: '買電力量',
    //     data: posts.a,
    //     backgroundColor: "rgba(205, 113, 169, 1)"
    // },
    // {
    //     type: "bar",
    //     label: "太陽光発電量",
    //     data: posts.b,
    //     backgroundColor: "rgba(205, 208, 31, 1)",
    // },
    // {
    //     type: "bar",
    //     label: "蓄電池放電量",
    //     data: posts.c,
    //     backgroundColor: "rgba(1, 220, 122, 1)",
    // },
    // {
    //     type: "bar",
    //     label: "蓄電池蓄電量",
    //     data: posts.d,
    //     backgroundColor: "rgba(1, 179, 235, 1)",
    //     stack: 'stack1'
    // }];
    const [label, setLabel] = useState('day');
    const [screenHeight] = useState("30vh");


    const legendMargin = {
        beforeInit(chart) {
            const originalFit = chart.legend.fit;
            chart.legend.fit = function fit() {
                originalFit.bind(chart.legend)();
                this.height += 20;
            }
        }
    }

    useEffect(() => {
        const dayLabel = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"];
        const weekLabel = ["11/27(土)", "11/28(日)", "11/29(月)", "11/30(火)", "12/1(水)", "12/2(木)", "12/3(金)"];
        const dateObj = new Date(date);
        const month = dateObj.getMonth();
        const year = dateObj.getFullYear();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const monthLabel = Array.from({ length: daysInMonth }, (_, i) => String(i + 1));
        const yearLabel = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

        switch (type) {
            case "day":
                setLabel(dayLabel);
                break;
            case "week":
                setLabel(weekLabel);
                // setDataset(defaultDataset);
                break;
            case "month":
                setLabel(monthLabel);
                // setDataset(defaultDataset);
                break;
            case "year":
                setLabel(yearLabel);
                // setDataset(defaultDataset);
                break;
            default: return null;
        }
        //eslint-disable-next-line
    }, [type]);

    useEffect(() => {
        if (posts === null) {
            return null;
        };

        // const max1 = parseFloat(Math.max(...posts.generation)) + 5;
        // const max2 = parseFloat(Math.max(...posts.consumption)) + 5;
        // const max3 = parseFloat(Math.max(...posts.purchase)) + 5;
        // const max4 = parseFloat(Math.max(...posts.discharge)) + 5;
        // const max5 = parseFloat(Math.max(...posts.charge)) + 5;
        const max1 = parseFloat(Math.max(...(checkData(posts.power_gene_str)))) + 5;
        const max2 = parseFloat(Math.max(...(checkData(posts.consumption_power)))) + 5;
        const max3 = parseFloat(Math.max(...(checkData(posts.recv_power)))) + 5;
        const max4 = parseFloat(Math.max(...(checkData(posts.dischrg_power)))) + 5;
        const max5 = parseFloat(Math.max(...(checkData(posts.chrg_power)))) + 5;
        let maxValue = [];

        posts.power_gene_str.forEach((data, index) => {
            const num1 = isNaN(data) ? 0 : data;
            const num2 = isNaN(posts.dischrg_power[index]) ? 0 : posts.dischrg_power[index];
            const num3 = isNaN(posts.recv_power[index]) ? 0 : posts.recv_power[index];
            maxValue.push(num1 + num2 + num3);
        })

        let maxVal = 80000;

        if (isAuto) {

            maxVal = parseFloat(Math.max(max1, max2, max3, max4, max5)) - 5;
            if (type === 'day') {
                maxVal = 2000000
            }
            else if (type === 'week') {
                maxVal = 1500000
            } else if (type === 'month') {
                maxVal = 1500000
            } else {
                maxVal = 40000000
            }

            const stepVal = parseInt(Math.round((maxVal) / 5));
            const step1 = parseInt(Math.round(max1 / 5));
            const step2 = parseInt(Math.round(max2 / 5));

            setChart({
                step: [step1, step2, stepVal],
                scale: [step1 * 5, step2 * 5, stepVal * 5]
            });
        } else {
            maxVal = parseFloat(Math.max(...(checkData(maxValue))));
            let final = maxVal > 100000 && maxVal < 1000000 ? roundToNearest(maxVal, 250000) : maxVal > 1000000 && maxVal < 10000000 ? roundToNearest(maxVal, 2500000) : maxVal > 10000000 && maxVal < 100000000 ? roundToNearest(maxVal, 25000000) : maxVal > 100000000 && maxVal < 1000000000 ? roundToNearest(maxVal, 250000000) : roundToNearest(maxVal + 5, 25000)
            const stepVal = parseInt(Math.round((final) / 5));
            // const stepVal = type === 'month' ? roundToNearest(parseInt(Math.round((final) / 5)), 100000) : type === 'year' ? roundToNearest(parseInt(Math.round(final / 5)), 1000000) : parseInt(Math.round((final) / 5));
            const step1 = parseInt(Math.round(max1 / 5));
            const step2 = parseInt(Math.round(max2 / 5));

            setChart({
                step: [step1, step2, stepVal],
                scale: [step1 * 5, step2 * 5, stepVal * 5]
            });
        }//eslint-disable-next-line
    }, [isAuto, posts, type]);

    if (posts === null) {
        return null;
    };

    const checkData = (values) => {
        let newValue = [];
        for (let i = 0; i < values.length; i++) {
            if (typeof values[i] === "number") {
                newValue.push(values[i].toFixed(0));

            } else {
                newValue.push(0);
            }
        }
        return newValue;
    }

    return <>
        <Col md={12} className="p-0 graphMaintain" style={{ height: screenHeight }}>
            {/* {type === 'day' ?
                <span className="scale-text">%</span> : ''
            }
            <span className="scale-text ml-4">Wh</span> */}
            <Bar
                id="top-chart"
                data={{
                    labels: label,
                    datasets: (type === 'day') ? [
                        {
                            type: "line",
                            label: "蓄電池充電率 [%]",
                            fill: false,
                            data: checkData(posts.soc),
                            borderColor: "#964b00",
                            // backgroundColor: "#964b00",
                            yAxisID: 'y1',
                            pointStyle: 'round',
                            pointRadius: 3,
                            pointBackgroundColor: "#964b00",
                            order: 1,
                            stack: 'stack0',
                        },
                        {
                            barPercentage: 0.9,
                            type: "bar",
                            label: "買電量 [kWh] ",
                            data: checkDatatype(posts.recv_power),
                            backgroundColor: "#cc0000",
                            borderColor: "#cc0000",
                            order: 2,
                            stack: 'stack0',


                        },
                        {
                            barPercentage: 0.9,
                            type: 'bar',
                            label: '発電量 [kWh]',
                            data: checkDatatype(posts.power_gene_str),
                            backgroundColor: "#008000",
                            borderColor: "#008000",
                            order: 2,
                            stack: 'stack0',



                        },
                        {
                            barPercentage: 0.9,
                            type: "bar",
                            label: "消費電力量 [kWh]",
                            data: checkDatatype(posts.consumption_power),
                            backgroundColor: "#a9a9a9",
                            borderColor: "#a9a9a9",
                            stack: 'stack1',
                            order: 2,
                        },
                        {
                            type: "bar",
                            barPercentage: 0.9,
                            label: "蓄電池放電量 [kWh]",
                            data: checkDatatype(posts.dischrg_power),
                            backgroundColor: "#0000ff",
                            borderColor: "#0000ff",
                            order: 2,
                            stack: 'stack0'
                        },
                        {
                            type: "bar",
                            barPercentage: 0.9,
                            label: "蓄電池充電量 [kWh]",
                            data: checkDatatype(posts.chrg_power),
                            backgroundColor: "#6600ff",
                            borderColor: "#6600ff",
                            order: 2,
                            stack: 'stack1'
                        },
                    ] : [
                        {
                            barPercentage: 0.9,
                            type: "bar",
                            label: "買電量 [kWh] ",
                            data: checkDatatype(posts.recv_power),
                            backgroundColor: "#cc0000",
                            borderColor: "#cc0000",
                            order: 2,
                            stack: 'stack0',


                        },
                        {
                            barPercentage: 0.9,
                            type: 'bar',
                            label: '発電量 [kWh]',
                            data: checkDatatype(posts.power_gene_str),
                            backgroundColor: "#008000",
                            borderColor: "#008000",
                            order: 2,
                            stack: 'stack0',



                        },
                        {
                            barPercentage: 0.9,
                            type: "bar",
                            label: "消費電力量 [kWh]",
                            data: checkDatatype(posts.consumption_power),
                            backgroundColor: "#a9a9a9",
                            borderColor: "#a9a9a9",
                            stack: 'stack1',
                            order: 2,
                        },
                        {
                            type: "bar",
                            barPercentage: 0.9,
                            label: "蓄電池放電量 [kWh]",
                            data: checkDatatype(posts.dischrg_power),
                            backgroundColor: "#0000ff",
                            borderColor: "#0000ff",
                            order: 2,
                            stack: 'stack0'
                        },
                        {
                            type: "bar",
                            barPercentage: 0.9,
                            label: "蓄電池充電量 [kWh]",
                            data: checkDatatype(posts.chrg_power),
                            backgroundColor: "#6600ff",
                            borderColor: "#6600ff",
                            order: 2,
                            stack: 'stack1'
                        },
                    ]
                }}
                options={{
                    resposive: true,
                    maintainAspectRatio: false,
                    animation: true,
                    barPercentage: 1,
                    elements: {
                        point: {
                            radius: 0
                        }
                    },
                    interaction: {
                        intersect: false,
                        mode: 'index'
                    },

                    plugins: {
                        tooltip: {
                            //enabled: false,
                            backgroundColor: "#000000",
                            //borderColor: 'rgba(0, 255, 255, 1)',
                            borderWidth: 1,
                            title: { display: false },
                            displayColors: true,
                            boxWidth: 5,
                            boxHeight: 25,
                            caretPadding: 20,
                            // xAlign: 'left',
                            yAlign: "center",
                            bodyFont: { size: 13 },
                            // bodyColor: 'black',
                            filter: function (context) {
                                // var label = context.dataset.data[context.dataIndex];
                                // if (label === 0) {
                                //     return false;
                                // } else {
                                return true;
                                // }
                            },
                            callbacks: {
                                title: function (tooltipItems, data) {
                                    //Return value for title
                                    if (type === 'day') {
                                        return `${format(new Date(date), 'yyyy/MM/dd')} ${tooltipItems[0].label}`;
                                    } if (type === 'month') {
                                        return `${format(new Date(date), 'yyyy/MM')}/${tooltipItems[0].label < 10 ? '0' + tooltipItems[0].label : tooltipItems[0].label}`;
                                    }
                                    if (type === 'year') {
                                        return `${format(new Date(date), 'yyyy')}/${tooltipItems[0].label < 10 ? '0' + tooltipItems[0].label : tooltipItems[0].label}`;
                                    }
                                },
                                label: function (context) {
                                    const label = context.dataset.label.split('[')[0].trim();
                                    if (context.dataset.label.includes("%")) {
                                        return `${label} : ${context.dataset.data[context.dataIndex]}% `
                                    } else {
                                        const value = formatGraphPower(context.dataset.data[context.dataIndex], 2)
                                        return `${label} : ${value} `;
                                    }
                                },

                            }
                        }, legend: {
                            onClick: (click, legendItem, legend) => {
                                const datasets = legend.legendItems.map((dataset, index) => {
                                    return dataset.text;
                                });
                                const index = datasets.indexOf(legendItem.text);
                                if (legend.chart.isDatasetVisible(index) === true) {
                                    legend.chart.hide(index);
                                } else {
                                    legend.chart.show(index);
                                }
                            },
                            labels: {
                                boxWidth: 40,
                                usePointStyle: true,
                                generateLabels: (chart) => {
                                    let visibility = [];
                                    for (let i = 0; i < chart.data.datasets.length; i++) {
                                        if (chart.isDatasetVisible(i) === true) {
                                            visibility.push(false);

                                        } else {
                                            visibility.push(true);
                                        }
                                    }
                                    let pointStyle = [];
                                    chart.data.datasets.forEach(dataset => {
                                        if (dataset.type === 'line') {
                                            pointStyle.push('line')

                                        }
                                        else {
                                            pointStyle.push('rect');
                                        }
                                    });
                                    return chart.data.datasets.map(
                                        (dataset, index) => ({
                                            text: dataset.label,
                                            fillStyle: dataset.backgroundColor,
                                            strokeStyle: dataset.borderColor,
                                            lineWidth: 3,
                                            pointStyle: pointStyle[index],
                                            hidden: visibility[index],

                                        })
                                    )
                                }
                            },

                        },
                    },
                    scales: {
                        y: {
                            min: 0,
                            max: chart.scale[2],
                            stacked: true,
                            grid: { display: true, borderColor: '#000000' },
                            ticks: {
                                padding: type === 'day' ? 17 : type === "month" ? 31 : 35,
                                stepSize: chart.step[2],
                                autoSkip: false,
                                maxTicksLimit: 6,
                                callback: (val, type) => {
                                    if (val === 0) {
                                        return "0";
                                    }
                                    // else if (val > 999999) {
                                    //     const newVal = val / 1000000;
                                    //     return newVal.toFixed(1) + 'M';
                                    // }
                                    else {
                                        return Math.round(val / 1000) + 'K';
                                    }
                                },

                                color: "#000000"

                            },
                            display: true,
                            position: 'left'
                        },
                        y1: (type === 'day') ? {
                            min: 0,
                            max: 100,
                            display: true,
                            position: 'left',
                            stacked: false,
                            grid: { display: false, borderColor: '#000000' },
                            ticks: {
                                stepSize: 20,
                                autoSkip: false,
                                color: "#000000",
                                maxTicksLimit: 6,

                                callback: (val) => {
                                    if (val === 0) {
                                        return "0";
                                    } else {
                                        return val;
                                    }
                                },

                            },
                        } :
                            { display: false, }
                        ,
                        x: {
                            grid: { display: true, borderColor: "#000000" },
                            stacked: true,

                            ticks: {
                                color: "#000000",

                            },


                        },

                    },
                    color: "#000000"

                }}
                plugins={[legendMargin, {
                    afterDraw: function (chart, easing) {
                        if (chart.tooltip._active && chart.tooltip._active.length) {
                            const activePoint = chart.tooltip._active[0];
                            const ctx = chart.ctx;
                            const x = activePoint.element.x;
                            const topY = chart.scales.y.top;
                            const bottomY = chart.scales.y.bottom;

                            // Check if activePosition is greater than 10
                            const reposition = type === 'day' ? 13 : type === "month" ? 18 : 7;
                            if (activePoint.index >= reposition) {
                                chart.tooltip.options.xAlign = 'right'; // Change xAlign to 'left'
                                chart.tooltip.options.caretPadding = type === 'year' ? 45 : 20;
                                // chart.tooltip.options.yAlign = 'right'; // Change xAlign to 'left'
                            } else {
                                chart.tooltip.options.xAlign = 'left'; // Reset xAlign to 'center' (default)
                                // chart.tooltip.options.yAlign = 'left'; // Reset xAlign to 'center' (default)
                            }

                            // Draw Vertical Line
                            ctx.save();
                            ctx.beginPath();
                            ctx.moveTo(x, topY);
                            ctx.lineTo(x, bottomY);
                            ctx.lineWidth = 2;
                            ctx.strokeStyle = '#000';
                            ctx.stroke();
                            ctx.restore();
                        }
                    }
                }]}
            />
            {type === 'day' ?
                <span className="scale-text graph1-text ml-2">%</span> : ''
            }
            <span className="scale-text graph1-text ml-5">Wh</span>
        </Col>
    </>;
};

export default ChartLayout;